import { Resource } from 'modules/core/base-resource';
import httpResource from '../../../core/http-resource';
import { CreateApplicationFromTokenInput, CreateApplicationFromTokenResponse } from '../interfaces/create-application-from-token';
import { TokenData } from '../interfaces/token-data';
import { TokenResponse } from '../interfaces/token-response';

class ApplicationsResource extends Resource {
  constructor() {
    super('application', httpResource);
  }

  public getToken(championshipId: number, teamId: number): Promise<TokenResponse> {
    return this.child('token').get({ championshipId, teamId });
  }

  public createFromToken(data: CreateApplicationFromTokenInput): Promise<CreateApplicationFromTokenResponse> {
    const { photo, ...rest } = data;

    const formData = new FormData();
    Object.entries(rest).forEach(([key, value]) => {
      if (value !== undefined) {
        formData.append(key, String(value));
      }
    });
    if (photo) {
      formData.append('photo', photo);
    }

    return this.child('create-from-token-v2').post(formData);
  }

  public decodeToken(token: string): Promise<TokenData> {
    return this.child('decode-token').get({ token });
  }
}

const applicationsResource = new ApplicationsResource();
export default applicationsResource;
